import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=9ebe9b50&scoped=true&"
import script from "./Guidance.vue?vue&type=script&lang=js&"
export * from "./Guidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebe9b50",
  null
  
)

export default component.exports